module.exports = __webpack_public_path__ + "media/hysteria.44f731e0.mp3";